import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AppDispatch, AppState } from 'app/redux/types/types';
import { RequestType } from 'app/pages/order/redux/model/order-request';

interface PendingMeta {
    requestType: RequestType;
}

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: AppState;
    dispatch: AppDispatch;
    pendingMeta: PendingMeta;
}>();
